module.exports = __webpack_public_path__ + "img/pantalla 5-1.70bfee2d.svg";